import React, { useCallback, useEffect, useMemo } from 'react'
import { Tile } from './Tile'
import './SelectionGrid.scss'
import { IFabricTile } from './redux/reducer';
import { useDispatch, useSelector } from 'react-redux';
import { switchFabricSelectorVisibility } from './redux/actions';
import { setProduct } from '../redux/actions/product';
import { useTranslation } from 'react-i18next';
import { OptionType } from '../controlpanel';
import { WizardScreenType } from '../editor/useFabricWizard';


interface FabricSelectionGridProps {
    tiles?: IFabricTile[],
    wizardScreen?:(screenType?:WizardScreenType)=>void,
    showBackButton?: boolean
}

export const FabricLibrary = (props: FabricSelectionGridProps) => {
    const { tiles = [], showBackButton=true } = props

    const selOptionType= useSelector((state: any) => state.fabricLibrary.selOptionType)
    

    const { t } = useTranslation();

    const dispatch = useDispatch();

    const sendToHost = useCallback((action, value=0) => {
        let url =
            window.location !== window.parent.location
                ? document.referrer
                : document.location.origin
    
        window.parent.postMessage(
            JSON.stringify({
                action,
                value
            }),
            url,
        )
      }, [window])

    const fabricGridTiles = useMemo(() => {
        return tiles.map((fabric) => ({
            id: fabric.productID,
            name: fabric.name,
            thumbnail: fabric.image,
            price: fabric.price,
            adjustedPrice: fabric.adjustedPrice,
            currency: fabric.currency,
            description: fabric.shortDescription.html,
            specialPrice: fabric.specialPrice.html,
            orderOptions: fabric.orderOptions,
            pUrl: fabric.pUrl
        }))
    }, [tiles])

    useEffect(() => {
        if (window.parent) {
            sendToHost('SCROLL_TO_TOP');
        }
        var elem = document.getElementById("fabricSelectionGrid");
        console.log("scroll height =====> " + elem?.scrollHeight);

        var delyaHt = 0;
        if (elem) var delyaHt = document.documentElement.offsetHeight - elem?.offsetHeight;

        var ht = elem?.scrollHeight;
        if (ht) {
            sendToHost('CALC_IFRAME_HEIGHT', ht+delyaHt);
        }
    }, [])

    const handleFabricSelection = useCallback((product, selOptionType) => {
        const updatedProduct = updateProduct(product, selOptionType)
        dispatch(setProduct({...updatedProduct, isSelectedFromWizard: true}))

        const isPrimary = updatedProduct.totalLength>100?true:false;
        dispatch(switchFabricSelectorVisibility(false, {
            isPrimary,
            name: updatedProduct.optionName,
            quantity: (isPrimary? 1: selOptionType.quantity)||1
        }, window.scrollY))
        props.wizardScreen && props.wizardScreen();
        if (window.parent) {
            sendToHost('SCROLL_TO_TOP');
//             var elem = document.getElementById("0"); // id of AddToCart button

//             var elem1 = document.getElementById("1"); // id of Sample1 (if it exists) button
//             var elem2 = document.getElementById("2"); // id of Sample2 (if it exists) button

//             if (elem2) {
//                 elem = elem2
//             } else if (elem1) {
//                 elem = elem1
//             }    

//             var ht = elem?.getBoundingClientRect();
            var ht = document.body.offsetHeight;
            if (ht) {
                //sendToHost('CALC_IFRAME_HEIGHT', ht.bottom);
                sendToHost('CALC_IFRAME_HEIGHT', ht);
            }
        }
    }, [])

    return <div className='fabric-library-container'>
        <div className='header'>
            {showBackButton?<button title="Back to Editor"
                    className='header__back'
                    onClick={()=>{
                    dispatch(switchFabricSelectorVisibility(false, selOptionType, null))
                    }} >
            </button>:null}
            <div className='title'>{t("editor.custom.choose-fabric")}</div>
        </div>
        <div id="fabricSelectionGrid" className='fabric-selection-grid'>
            {fabricGridTiles.filter(tile => tile.id).map((tile, index) => {
                return <Tile {...tile} key={tile.id} selectFabric={()=>{
                    handleFabricSelection(tiles[index], selOptionType)
                }} />
            })}
        </div>
    </div>
}

const updateProduct = (product: any, orderOption?:OptionType) => {
    let index = (product.orderOptions || []).findIndex((option: any) => option.name === orderOption?.name)
    index = index + 1? index: 0
    const optionToSelect = product.orderOptions?.length && product.orderOptions[index]
    const isPrimary=!optionToSelect || !!optionToSelect.totalLength
    const optionQty = (!optionToSelect || optionToSelect.totalLength ? 1: orderOption?.quantity)||1
    return {
        ...product,
        isPrimary,
        ...product.orderOptions?.length && {
            productID: product.orderOptions[index].productID,
            width: product.orderOptions[index].width,
            totalLength: product.orderOptions[index].totalLength || product.orderOptions[index].height,
            price: product.orderOptions[index].price * optionQty,
            basePrice: product.orderOptions[index].price,
            optionName: product.orderOptions[index].name,     
        }
    }
}